<template>
  <f7-page name="credits-transfer" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('TransferHistory') }}</f7-nav-title>
      <f7-nav-right>
        <label :for="`submit-${submitId}`" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>

    <!--<f7-block-title>{{ $t('TransferCredits') }}</f7-block-title>-->
    <f7-block>
      <p>{{ $t('TransferHistoryDescription') }}</p>
    </f7-block>

    <form action="" @submit.prevent="onSubmit">
      <input type="submit" :id="`submit-${submitId}`" hidden >

      <f7-list class="no-margin-top no-hairline-bottom">
        <li>
          <div class="item-content item-input">
            <div class="item-media">
              <f7-icon icon="f7-icons icon-live-date text-color-lightgray"></f7-icon>
            </div>
            <div class="item-inner">
              <div class="item-title item-label">{{ $t('MonthToSearchIn') }}</div>
              <div class="item-input-wrap">
                <input ref="CalendarMonth" type="text" readonly="readonly" />
              </div>
            </div>
          </div>
        </li>
        <li class="item-input custom-smart-select-wrapper">
          <a ref="AutocompleteTransferTo" class="item-link item-content" href="#" id="autocomplete-standalone-ajax">
            <input type="hidden" :value="SelectedCustomerCode"/>
            <span class="item-media">
              <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
            </span>
            <div class="item-inner">
              <div class="item-title">{{ $t('FromCustomer') }}</div>
              <div class="item-after">{{ SelectedUserName }}</div>
            </div>
          </a>
        </li>
      </f7-list>

    </form>

    <f7-block v-if="!isLoading && isNoData">
      <p>{{ $t('NoDataFound') }}</p>
    </f7-block>

    <f7-list
        ref="vl"
        class="vl vl-transfer-history no-hairlines"
        virtual-list
        media-list
        :virtual-list-params="{ items, renderExternal, height: heightCalc }"
    >
      <ul>
        <f7-list-item
            v-for="(item, index) in vlData.items"
            :key="index"
            :title="item.ToCustomerName"
            :header="dateFormat(item.CreateTime+'+0000', 'datetime')"
            :after="`${ item.Credits} ${ $t('Credits') }`"
            :text="`${ $t('LoginName') }: ${item.ToUserName}`"
            :style="`top: ${vlData.topPosition}px`"
        >
        </f7-list-item>
      </ul>
    </f7-list>
  </f7-page>
</template>
<!--CreateTime: "2021-08-17T14:34:27.93"
CreatorCode: "55e877dc-8e28-42b9-947f-564c8c7dcdea"
CreatorName: "quiktrakukraine"
Credits: 10
FromCustomerCode: "573dabe1-e885-440f-b651-58957aaf3c1a"
FromCustomerName: "Quiktrak Ukraine Limited"
FromUserCode: "55e877dc-8e28-42b9-947f-564c8c7dcdea"
FromUserName: "quiktrakukraine"
Source: ""
ToCustomerCode: "5ba7b321-b6e6-467f-b1b7-710fb534a207"
ToCustomerName: "4TEST"
ToUserCode: "a21c0da6-38ae-4be6-ab02-eed7aaf98a5d"
ToUserName: "4TEST"-->
<script>
import {mapGetters} from "vuex";
import {f7, theme} from "framework7-vue";
import {QTAPI} from "../../services/qt-api";
import {dateFormat} from "../../js/helpers"

export default {
  name: "credits-transfer",

  props: {
    f7router: Object,
    f7route: Object,
  },

  data() {
    return {
      submitId: f7.utils.id(),
      isLoading: false,
      isNoData: false,

      credits: 10,
      MinSearchLength: 2,
      SelectedCustomerCode: null,
      SelectedUserName: null,
      autocompleteTransferTo: null,
      calendarMonth: null,

      items: [],
      vlData: {
        items: [],
      },
      vl: null,
    }
  },

  computed: {
    ...mapGetters(['UserInfo', 'MajorToken', 'MinorToken']),
  },

  mounted() {
    let self = this
    this.vl = f7.virtualList.get('.vl-transfer-history');

    self.autocompleteTransferTo = f7.autocomplete.create({
      openIn: 'page', //open in page
      openerEl: self.$refs.AutocompleteTransferTo, //link that opens autocomplete
      valueProperty: 'Code', //object's "value" property name
      textProperty: 'customDisplayName', //object's "text" property name
      closeOnSelect: true,
      autoFocus: true,
      limit: 50,
      preloader: true, //enable preloader
      searchbarPlaceholder: self.$t('EnterMinCharacters', {q: self.MinSearchLength}),
      source: async function (query, render) {
        let autocomplete = this;

        if (query.length < self.MinSearchLength) {
          return;
        }
        // Show Preloader
        autocomplete.preloaderShow();

        let data = {
          MajorToken: self.MajorToken,
          MinorToken: self.MinorToken,
          page: 1,
          rows: 20,
          sort: 'Name',
          order: 'asc',
          q: query,
        }
        let response = await QTAPI.GetCustomers(data)
        autocomplete.preloaderHide();
        if(!response || !response.rows){
          render([]);
          return
        }

        for (var i = 0; i < response.rows.length; i++) {
          response.rows[i].customDisplayName = `${ response.rows[i].Name } (${ response.rows[i].Email })`
        }

        render(response.rows);
      },
      on: {
        change: function (value) {
          var itemText = [],
              inputValue = [];
          for (var i = 0; i < value.length; i++) {
            itemText.push(value[i].customDisplayName);
            inputValue.push(value[i].UserCode);
          }
          self.SelectedCustomerCode = inputValue.join(', ')
          self.SelectedUserName = itemText.join(', ')
        },
      },
    });

    let today = new Date();
    self.calendarMonth = f7.picker.create({
      //containerEl: '#demo-picker-date-container',
      inputEl: self.$refs.CalendarMonth,
      toolbar: true,
      rotateEffect: true,
      value: [
        today.getMonth(),
        today.getFullYear(),
      ],
      formatValue: function (values, displayValues) {
        return displayValues[0] + ', ' + displayValues[1];
      },
      cols: [
        // Months
        {
          values: [0,1,2,3,4,5,6,7,8,9,10,11],
          displayValues: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          textAlign: 'left'
        },
        // Space divider
        {
          divider: true,
          content: '&nbsp;&nbsp;'
        },
        // Years
        {
          values: (function () {
            var arr = [];
            for (var i = 1950; i <= 2030; i++) { arr.push(i); }
            return arr;
          })(),
        },


      ],
    });

  },
  beforeUnmount() {
    const self = this;
    // Destroy popup when page removed
    if (self.autocompleteTransferTo) self.autocompleteTransferTo.destroy();
    if (self.calendarMonth) self.calendarMonth.destroy();
  },

  methods: {
    dateFormat(...options){
      return dateFormat(...options)
    },
    async onSubmit(){
      let calendarValues = this.calendarMonth.getValue()
      let data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        FromCustomerCode: !this.SelectedCustomerCode ? this.MajorToken : this.SelectedCustomerCode,
        Year: calendarValues[1],
        Month: calendarValues[0]+1
      }

      this.isLoading = true;
      let response = await QTAPI.GetCreditsTransferHistory(data)
      this.isLoading = false;
      if (!response || !Array.isArray(response) ){
        return
      }
      console.log(response)
      this.isNoData = !response.length;
      if(response.length){
        //result = SortArrayByObjProps([...result], [{prop: 'Name', direction: 1}])
        //response = this.formatAlertHistory(response)
        this.vl.replaceAllItems(response);
      }else{
        this.vl.deleteAllItems()
      }
     /* this.$store.dispatch('GetCreditBalance')
      f7.dialog.alert(this.$t('CreditTransferred', { name: this.SelectedUserName, credits: response.To.Credits }), this.$t('Success'))
      this.f7router.back()*/
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    heightCalc(){
      return theme.ios ? 80 : 86;
    },
  }
}
</script>

<style scoped>

</style>